import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { MapaUnicoPuntoComponent } from '../../../auxiliares/mapa-unico-punto/mapa-unico-punto.component';
import { ActivosRoutingModule } from './routing';
import { MapaFacilComponent } from '../../../auxiliares/mapa-facil/mapa-facil.component';
import { MapaFacilV2Component } from '../../../auxiliares/mapbox/mapa-facil-v2.component';
import { DateRangeSelectorComponent } from '../../../auxiliares/date-range-selector/date-range-selector.component';
import { ListadoActivosComponent } from './activos/listado-activos/listado-activos.component';
import { CrearEditarActivoComponent } from './activos/crear-editar-activo/crear-editar-activo.component';
import { MapaActivosComponent } from './mapa-activos/mapa-activos.component';
import { FlotanteActivosComponent } from './mapa-activos/flotante-activos/flotante-activos.component';
import { IslaActivosComponent } from './mapa-activos/isla-activos/isla-activos.component';
import { MapDrawMapboxComponent } from '../../../auxiliares/map-draw-mapbox/map-draw-mapbox.component';
import { DetallesActivoInfoComponent } from './activos/detalles-activo-info/detalles-activo-info.component';
import { DetallesActivoComponent } from './activos/detalles-activo/detalles-activo.component';
import { InfoPuntoComponent } from './activos/detalles-activos-mapa/info-punto/info-punto.component';
import { ListadoConfigsEventosComponent } from '../../standalone/configs-eventos/listado-configs-eventos/listado-configs-eventos.component';
import { ListadoNotasComponent } from '../../standalone/notas/listado-notas/listado-notas.component';
import { ListadoConfigEventoUsuarioComponent } from '../../standalone/config-evento-usuario/listado-config-evento-usuario/listado-config-evento-usuario.component';
import { JerarquiaClienteComponent } from '../../standalone/jerarquia-cliente/jerarquia-cliente.component';
import { CardComponent } from '../../../auxiliares/cards/cards.component';
import { DetallesActivoMapaRecorridoComponent } from './activos/detalles-activo-mapa-recorrido/detalles-activo-mapa-recorrido.component';
import { ActivoRecorridoComponent } from './activos/detalles-activo-mapa-recorrido/activo-recorrido/activo-recorrido.component';
import { DatetimePickerComponent } from '../../../auxiliares/datetime-picker/datetime-picker.component';
import { SelectorTipoMapaComponent } from '../../standalone/selector-tipo-mapa/selector-tipo-mapa.component';
import { MostrarServiciosComponent } from '../../../auxiliares/mostrar-servicios/mostrar-servicios.component';
import { InfoTableComponent } from '../../../componentes/info-table/info-table.component';
import { MapCardComponent } from '../../../componentes/map-card/map-card.component';
import { LoadingComponent } from '../../../componentes/loading/loading.component';
import { ContentCardComponent } from '../../../componentes/content-card/content-card.component';
import { EventosGenericosModule } from '../eventos-genericos/module';
import { AdministracionModule } from '../administracion/module';
import { ConfigHorariosAtencionComponent } from '../../standalone/config-horarios-atencion/config-horarios-atencion.component';
import { ListadoAsignacionsComponent } from '../../standalone/asignacions/listado-asignacions/listado-asignacions.component';
import { PIEZAS_DETALLE } from '../../../componentes/detalle/detalle.components';

@NgModule({
  declarations: [
    //Activos
    ListadoActivosComponent,
    CrearEditarActivoComponent,
    DetallesActivoComponent,
    InfoPuntoComponent,
    DetallesActivoInfoComponent,

    //Mapa Activos
    MapaActivosComponent,
    FlotanteActivosComponent,
    IslaActivosComponent,
    DetallesActivoMapaRecorridoComponent,
    ActivoRecorridoComponent,
  ],
  imports: [
    CommonModule,
    AuxiliaresModule,
    ActivosRoutingModule,
    MapaUnicoPuntoComponent,
    MapaFacilComponent,
    MapaFacilV2Component,
    DateRangeSelectorComponent,
    MapDrawMapboxComponent,
    ListadoNotasComponent,
    ListadoConfigEventoUsuarioComponent,
    JerarquiaClienteComponent,
    CardComponent,
    ListadoConfigsEventosComponent,
    DatetimePickerComponent,
    SelectorTipoMapaComponent,
    MostrarServiciosComponent,
    InfoTableComponent,
    MapCardComponent,
    LoadingComponent,
    ContentCardComponent,
    EventosGenericosModule,
    AdministracionModule,
    ConfigHorariosAtencionComponent,
    ListadoAsignacionsComponent,
    ...PIEZAS_DETALLE,
  ],
})
export class ActivosModule {}
